/** RollenPage — Administration › Rollen & Rechte (Story UI-U6 AC4, kind='rolle'). */
import { ADMIN_PAGE_META } from '../adminNav';
import { RolesPageBase } from './RolesPageBase';

const meta = ADMIN_PAGE_META.rollen;

export function RollenPage() {
  return (
    <RolesPageBase
      kind="rolle"
      title={meta.title}
      description={meta.description}
      createLabel="Neue Rolle"
      emptyLabel="Noch keine Rollen definiert."
    />
  );
}
